import { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { redirect } from '../../common/utils/redirectionUtils'

import LocationIcon from '../../assets/LocationIcon'
import {
  PAGE_CONST,
  ADDRESS_ENTRY_TYPE,
} from '../../common/constant/page-constant'
import CustomMap from '../../components/CustomMap/CustomMap'
import { createAccountHelper } from '../../helper/create-account-helper'
import {
  getDivisionsPublicHelper,
  getDistrictsPublicHelper,
  getPoliceStationsPublicHelper,
  getPostOfficesPublicHelper,
} from '../../helper/address-helper'
import LoginLeft from '../Login/LoginLeft'
import './CreateAccount.scss'

function CreateAccount(props) {
  const [isFieldErrorVisible, setIsFieldErrorVisible] = useState(false)
  const [showMap, setShowMap] = useState(false)

  const [pharmacyName, setPharmacyName] = useState(undefined)
  const [category, setCategory] = useState(undefined)
  const [locationString, setLocationString] = useState(undefined)
  const [latitude, setLatitude] = useState(undefined)
  const [longitude, setLongitude] = useState(undefined)
  const [addressComponent, setAddressComponent] = useState(undefined)
  const [placeId, setPlaceId] = useState(undefined)
  const [ownerName, setOwnerName] = useState(undefined)
  const [areaCode, setAreaCode] = useState(undefined)
  const [ownerPhoneNumber, setOwnerPhoneNumber] = useState(undefined)
  const [ownerEmail, setOwnerEmail] = useState(undefined)
  const [designation, setDesignation] = useState(undefined)
  const [password, setPassword] = useState(undefined)
  const [confirmPassword, setConfirmPassword] = useState(undefined)
  const [err, setErr] = useState('')
  const [isPasswordErrorVisible, setIsPasswordErrorVisible] = useState(false)
  const [termsAccepted, setTermsAccepted] = useState(false)

  const [addressEntryType, setAddressEntryType] = useState(ADDRESS_ENTRY_TYPE.MANUAL)
  const [villageHouse, setVillageHouse] = useState('')
  const [roadBlockSector, setRoadBlockSector] = useState('')
  const [divisionId, setDivisionId] = useState('')
  const [divisionName, setDivisionName] = useState('')
  const [districtId, setDistrictId] = useState('')
  const [districtName, setDistrictName] = useState('')
  const [policeStationId, setPoliceStationId] = useState('')
  const [policeStationName, setPoliceStationName] = useState('')
  const [postOfficeId, setPostOfficeId] = useState('')
  const [postOfficeName, setPostOfficeName] = useState('')
  const [postCode, setPostCode] = useState('')

  const [divisions, setDivisions] = useState([])
  const [districts, setDistricts] = useState([])
  const [policeStations, setPoliceStations] = useState([])
  const [postOffices, setPostOffices] = useState([])
  const [addressLoading, setAddressLoading] = useState(false)

  const navigate = useNavigate()

  useEffect(() => {
    getDivisionsPublicHelper()
      .then((res) => setDivisions(res || []))
      .catch((err) => console.log('Error loading divisions:', err))
  }, [])

  const handleSignIn = () => {
    redirect(navigate, PAGE_CONST.LOGIN)
  }

  const handleAddressEntryTypeChange = (type) => {
    setAddressEntryType(type)
  }

  const handleDivisionChange = (value, name) => {
    setDivisionId(value)
    setDivisionName(name)
    setDistrictId('')
    setDistrictName('')
    setPoliceStationId('')
    setPoliceStationName('')
    setPostOfficeId('')
    setPostOfficeName('')
    setPostCode('')
    setDistricts([])
    setPoliceStations([])
    setPostOffices([])

    if (value) {
      setAddressLoading(true)
      getDistrictsPublicHelper(value)
        .then((res) => {
          setDistricts(res || [])
          setAddressLoading(false)
        })
        .catch((err) => {
          console.log('Error loading districts:', err)
          setAddressLoading(false)
        })
    }
  }

  const handleDistrictChange = (value, name) => {
    setDistrictId(value)
    setDistrictName(name)
    setPoliceStationId('')
    setPoliceStationName('')
    setPostOfficeId('')
    setPostOfficeName('')
    setPostCode('')
    setPoliceStations([])
    setPostOffices([])

    if (value) {
      setAddressLoading(true)
      getPoliceStationsPublicHelper(value)
        .then((res) => {
          setPoliceStations(res || [])
          setAddressLoading(false)
        })
        .catch((err) => {
          console.log('Error loading police stations:', err)
          setAddressLoading(false)
        })
    }
  }

  const handlePoliceStationChange = (value, name) => {
    setPoliceStationId(value)
    setPoliceStationName(name)
    setPostOfficeId('')
    setPostOfficeName('')
    setPostCode('')
    setPostOffices([])

    if (value) {
      setAddressLoading(true)
      getPostOfficesPublicHelper(value)
        .then((res) => {
          setPostOffices(res || [])
          setAddressLoading(false)
        })
        .catch((err) => {
          console.log('Error loading post offices:', err)
          setAddressLoading(false)
        })
    }
  }

  const handlePostOfficeChange = (value, name, code) => {
    setPostOfficeId(value)
    setPostOfficeName(name)
    setPostCode(code)
  }

  const handleLocationInputClick = () => {
    setShowMap(true)
  }

  const handleLocationSave = (
    selected,
    selectedString,
    placeId,
    addressComponent
  ) => {
    setLocationString(selectedString)
    setLatitude(selected?.lat)
    setLongitude(selected?.lng)
    setPlaceId(placeId)
    setAddressComponent(addressComponent)
    setShowMap(false)
  }

  const buildFullAddressString = () => {
    const parts = []
    if (villageHouse) parts.push(villageHouse)
    if (roadBlockSector) parts.push(roadBlockSector)
    if (postOfficeName) parts.push(postOfficeName)
    if (policeStationName) parts.push(policeStationName)
    if (districtName) parts.push(districtName)
    if (divisionName) parts.push(divisionName)
    if (postCode) parts.push(postCode)
    return parts.join(', ')
  }

  const handleCreateAccountValidation = () => {
    setIsPasswordErrorVisible(false)
    if (password !== confirmPassword) {
      setIsPasswordErrorVisible(true)
      return false
    }

    let isAddressValid = false
    if (addressEntryType === ADDRESS_ENTRY_TYPE.MANUAL) {
      isAddressValid = divisionId && districtId && policeStationId && postOfficeId
    } else {
      isAddressValid = locationString && latitude && longitude
    }

    return (
      pharmacyName &&
      category &&
      isAddressValid &&
      ownerName &&
      ownerPhoneNumber &&
      designation &&
      password &&
      confirmPassword &&
      termsAccepted
    )
  }

  const handleCreateAccount = () => {
    if (!handleCreateAccountValidation()) {
      setIsFieldErrorVisible(true)
      return
    }

    setIsFieldErrorVisible(false)

    let data = {
      pharmacyName,
      category,
      ownerName,
      areaCode,
      ownerPhoneNumber,
      ownerEmail,
      designation,
      password,
      addressType: addressEntryType,
    }

    if (addressEntryType === ADDRESS_ENTRY_TYPE.MANUAL) {
      data.locationString = buildFullAddressString()
      data.villageHouse = villageHouse
      data.roadBlockSector = roadBlockSector
      data.divisionId = divisionId
      data.divisionName = divisionName
      data.districtId = districtId
      data.districtName = districtName
      data.policeStationId = policeStationId
      data.policeStationName = policeStationName
      data.postOfficeId = postOfficeId
      data.postOfficeName = postOfficeName
      data.postCode = postCode
    } else {
      data.locationString = locationString
      data.latitude = latitude
      data.longitude = longitude
      data.placeId = placeId
      data.addressComponent = addressComponent
    }

    console.log('res: ', data)

    createAccountHelper(data)
      .then((res) => {
        console.log('res: ', res)
        redirect(navigate, PAGE_CONST.LOGIN)
      })
      .catch((err) => {
        setErr(err)
      })
  }

  const handleLocationCancel = () => {
    setLatitude(undefined)
    setLongitude(undefined)
    setLocationString(undefined)
    setPlaceId(undefined)
    setAddressComponent(undefined)
    setShowMap(false)
  }

  return (
    <>
      <main className="loginPage createAccount dFlex jcSpaceBetween flexNowrap">
        <LoginLeft />
        <div className="loginRight">
          <div className="loginRightControl">
            <div className="login-content">
              <div className="welcomeHeading">
                <span>CREATE ACCOUNT</span>
              </div>
              <div className="welcomeDesc">
                Please fill in the details to create your account
              </div>
            </div>
            <form onSubmit={(e) => e.preventDefault()}>
              <div className="formSection">
                <div className="formHeading">Pharmacy Details</div>
                <div className="formInline dFlex flexNowrap">
                  <div className="formGroup formFloating fgrow1">
                    <input
                      type="text"
                      className="formControl"
                      id="pharmacyname"
                      placeholder="Pharmacy Name"
                      value={pharmacyName}
                      onChange={(e) => {
                        setErr('')
                        setPharmacyName(e.target.value)
                      }}
                      required
                    />
                    <label for="pharmacyname">Pharmacy Name</label>
                    {isFieldErrorVisible && !pharmacyName && (
                      <div class="invalidFeedback">
                        Please select a valid Pharmacy Name.
                      </div>
                    )}
                  </div>
                  <div className="formGroup formFloating ml-4 fgrow1">
                    <select
                      className="formSelect"
                      id="floatingSelect"
                      onChange={(e) => {
                        setErr('')
                        console.log('value: ', e.target.value)
                        setCategory(e.target.value)
                      }}
                    >
                      <option value="none" selected disabled hidden>
                        Select an Option
                      </option>
                      <option value="RETAIL">Retail</option>
                      <option value="HOSPITAL">Hospital</option>
                    </select>
                    <label for="floatingSelect">Category</label>
                    {isFieldErrorVisible && !category && (
                      <div class="invalidFeedback">Please choose Category.</div>
                    )}
                  </div>
                </div>
                <div className="addressToggleWrap">
                  <label className="toggleLabel">Address Entry Method</label>
                  <div className="addressToggle">
                    <button
                      type="button"
                      className={`toggleBtn ${addressEntryType === ADDRESS_ENTRY_TYPE.MANUAL ? 'active' : ''}`}
                      onClick={() => handleAddressEntryTypeChange(ADDRESS_ENTRY_TYPE.MANUAL)}
                    >
                      Manual Entry
                    </button>
                    <button
                      type="button"
                      className={`toggleBtn ${addressEntryType === ADDRESS_ENTRY_TYPE.GOOGLE ? 'active' : ''}`}
                      onClick={() => handleAddressEntryTypeChange(ADDRESS_ENTRY_TYPE.GOOGLE)}
                    >
                      Google Maps
                    </button>
                  </div>
                </div>

                {addressEntryType === ADDRESS_ENTRY_TYPE.MANUAL && (
                  <div className="manualAddressForm">
                    <div className="formGroup formFloating">
                      <input
                        type="text"
                        className="formControl"
                        id="villageHouse"
                        placeholder="Village/House No."
                        value={villageHouse}
                        onChange={(e) => {
                          setErr('')
                          setVillageHouse(e.target.value)
                        }}
                      />
                      <label htmlFor="villageHouse">Village/House No.</label>
                    </div>

                    <div className="formGroup formFloating">
                      <input
                        type="text"
                        className="formControl"
                        id="roadBlockSector"
                        placeholder="Road/Block/Sector"
                        value={roadBlockSector}
                        onChange={(e) => {
                          setErr('')
                          setRoadBlockSector(e.target.value)
                        }}
                      />
                      <label htmlFor="roadBlockSector">Road/Block/Sector</label>
                    </div>

                    <div className="formGroup formFloating">
                      <select
                        className="formSelect"
                        id="division"
                        value={divisionId}
                        onChange={(e) => {
                          setErr('')
                          const selectedOption = divisions.find(d => d.id === parseInt(e.target.value))
                          handleDivisionChange(e.target.value, selectedOption?.name || '')
                        }}
                      >
                        <option value="">Select Division</option>
                        {divisions.map((division) => (
                          <option key={division.id} value={division.id}>
                            {division.name}
                          </option>
                        ))}
                      </select>
                      <label htmlFor="division">Division</label>
                      {isFieldErrorVisible && !divisionId && (
                        <div className="invalidFeedback">Please select a Division.</div>
                      )}
                    </div>

                    <div className="formGroup formFloating">
                      <select
                        className="formSelect"
                        id="district"
                        value={districtId}
                        onChange={(e) => {
                          setErr('')
                          const selectedOption = districts.find(d => d.id === parseInt(e.target.value))
                          handleDistrictChange(e.target.value, selectedOption?.name || '')
                        }}
                        disabled={!divisionId || addressLoading}
                      >
                        <option value="">Select District</option>
                        {districts.map((district) => (
                          <option key={district.id} value={district.id}>
                            {district.name}
                          </option>
                        ))}
                      </select>
                      <label htmlFor="district">District</label>
                      {isFieldErrorVisible && !districtId && (
                        <div className="invalidFeedback">Please select a District.</div>
                      )}
                    </div>

                    <div className="formGroup formFloating">
                      <select
                        className="formSelect"
                        id="policeStation"
                        value={policeStationId}
                        onChange={(e) => {
                          setErr('')
                          const selectedOption = policeStations.find(p => p.id === parseInt(e.target.value))
                          handlePoliceStationChange(e.target.value, selectedOption?.name || '')
                        }}
                        disabled={!districtId || addressLoading}
                      >
                        <option value="">Select Police Station</option>
                        {policeStations.map((station) => (
                          <option key={station.id} value={station.id}>
                            {station.name}
                          </option>
                        ))}
                      </select>
                      <label htmlFor="policeStation">Police Station</label>
                      {isFieldErrorVisible && !policeStationId && (
                        <div className="invalidFeedback">Please select a Police Station.</div>
                      )}
                    </div>

                    <div className="formGroup formFloating">
                      <select
                        className="formSelect"
                        id="postOffice"
                        value={postOfficeId}
                        onChange={(e) => {
                          setErr('')
                          const selectedOption = postOffices.find(p => p.id === parseInt(e.target.value))
                          handlePostOfficeChange(e.target.value, selectedOption?.name || '', selectedOption?.post_code || '')
                        }}
                        disabled={!policeStationId || addressLoading}
                      >
                        <option value="">Select Post Office</option>
                        {postOffices.map((office) => (
                          <option key={office.id} value={office.id}>
                            {office.name}
                          </option>
                        ))}
                      </select>
                      <label htmlFor="postOffice">Post Office</label>
                      {isFieldErrorVisible && !postOfficeId && (
                        <div className="invalidFeedback">Please select a Post Office.</div>
                      )}
                    </div>

                    <div className="formGroup formFloating">
                      <input
                        type="text"
                        className="formControl"
                        id="postCode"
                        placeholder="Post Code"
                        value={postCode}
                        readOnly
                      />
                      <label htmlFor="postCode">Post Code</label>
                    </div>
                  </div>
                )}

                {addressEntryType === ADDRESS_ENTRY_TYPE.GOOGLE && (
                  <div className="formGroup formFloating fgrow1 relative">
                    <input
                      type="text"
                      className="formControl"
                      id="location"
                      placeholder="Location"
                      value={locationString}
                      autoComplete="off"
                      onClick={handleLocationInputClick}
                      readOnly
                      required
                    />
                    <label htmlFor="location">Location</label>
                    {isFieldErrorVisible && !locationString && (
                      <div className="invalidFeedback">Please Choose Location.</div>
                    )}
                    <div
                      className="positionedIcon"
                      onClick={() => handleLocationInputClick()}
                    >
                      <LocationIcon />
                    </div>
                  </div>
                )}
              </div>
              <div className="formSection">
                <div className="formHeading">Owner Details</div>
                <div className="formGroup formFloating fgrow1">
                  <input
                    type="text"
                    className="formControl"
                    id="name"
                    placeholder="Name"
                    value={ownerName}
                    onChange={(e) => {
                      setErr('')
                      setOwnerName(e.target.value)
                    }}
                    required
                  />
                  <label for="name">Name</label>
                  {isFieldErrorVisible && !ownerName && (
                    <div class="invalidFeedback">Please Enter Name.</div>
                  )}
                </div>
                <div className="formInline dFlex flexNowrap">
                  <div className="formGroup formFloating fgrow1 maxWidth mb-0">
                    <select
                      className="formSelect"
                      id="floatingSelect"
                      onChange={(e) => {
                        setErr('')
                        setAreaCode(e.target.value)
                      }}
                    >
                      {/* <option value="1">+91</option> */}
                      <option value="2">+88</option>
                    </select>
                    <label for="floatingSelect">Country</label>
                    {false && (
                      <div class="invalidFeedback">
                        Please choose country code.
                      </div>
                    )}
                  </div>
                  <div className="formGroup formFloating ml-4 fgrow1 mb-0">
                    <input
                      type="text"
                      className="formControl"
                      id="phone"
                      pattern="[0-9]{11}"
                      maxLength={11}
                      minLength={10}
                      placeholder="Phone Number"
                      value={ownerPhoneNumber}
                      onChange={(e) => {
                        setErr('')
                        const inputText = e.target.value
                        const numericInput = inputText.replace(/\D/g, '')
                        setOwnerPhoneNumber(numericInput)
                      }}
                      required
                    />
                    <label for="phone">Phone Number</label>
                    {isFieldErrorVisible && !ownerPhoneNumber && (
                      <div class="invalidFeedback">
                        Please select a valid Phone Number.
                      </div>
                    )}
                  </div>
                </div>
                <div className="formGroup formFloating fgrow1">
                  <input
                    type="text"
                    className="formControl"
                    id="email"
                    placeholder="Email"
                    value={ownerEmail}
                    onChange={(e) => {
                      setErr('')
                      setOwnerEmail(e.target.value)
                    }}
                    required
                  />
                  <label for="name">Email</label>
                  {isFieldErrorVisible && !ownerEmail && (
                    <div class="invalidFeedback">Please Enter Email.</div>
                  )}
                </div>
                <div className="formGroup formFloating fgrow1">
                  <input
                    type="text"
                    className="formControl"
                    id="designation"
                    placeholder="Designation"
                    value={designation}
                    onChange={(e) => {
                      setErr('')
                      setDesignation(e.target.value)
                    }}
                    required
                  />
                  <label for="designation">Designation</label>
                  {isFieldErrorVisible && !designation && (
                    <div class="invalidFeedback">Please Enter Designation.</div>
                  )}
                </div>
              </div>
              <div className="formSection">
                <div className="formHeading">Password</div>
                <div className="formGroup formFloating">
                  <input
                    type="password"
                    className="formControl"
                    id="password"
                    placeholder="Password"
                    value={password}
                    onChange={(e) => {
                      setErr('')
                      setPassword(e.target.value)
                    }}
                    required
                  />
                  <label for="password">Password</label>
                  {isFieldErrorVisible && !password && (
                    <div class="invalidFeedback">
                      Please enter a valid Password.
                    </div>
                  )}
                </div>
                <div className="formGroup formFloating">
                  <input
                    type="password"
                    className="formControl"
                    id="confirmpassword"
                    placeholder="Confirm Password"
                    value={confirmPassword}
                    onChange={(e) => {
                      setErr('')
                      setConfirmPassword(e.target.value)
                    }}
                    required
                  />
                  <label for="confirmpassword">Confirm Password</label>
                  {isFieldErrorVisible && !confirmPassword && (
                    <div class="invalidFeedback">
                      Please enter a valid Confirm Password.
                    </div>
                  )}

                  {isPasswordErrorVisible && password !== confirmPassword && (
                    <div class="invalidFeedback">Password does not match.</div>
                  )}
                </div>
              </div>
              <div className="termsCheckboxWrapper">
                <label className="termsCheckbox">
                  <input
                    type="checkbox"
                    checked={termsAccepted}
                    onChange={(e) => setTermsAccepted(e.target.checked)}
                  />
                  <span className="checkmark"></span>
                  <span className="termsText">
                    I agree to the{' '}
                    <a href="/terms-and-conditions" target="_blank" rel="noopener noreferrer">
                      Terms & Conditions
                    </a>{' '}
                    and{' '}
                    <a href="/privacy-policy" target="_blank" rel="noopener noreferrer">
                      Privacy Policy
                    </a>
                  </span>
                </label>
                {isFieldErrorVisible && !termsAccepted && (
                  <div className="invalidFeedback">
                    Please accept the Terms & Conditions and Privacy Policy.
                  </div>
                )}
              </div>
              {err && <div class="invalidFeedback">{err}</div>}
              <button
                className="btn btnPrimary block space"
                onClick={handleCreateAccount}
              >
                Create Account
              </button>
            </form>
            <div className="createAccountWrap">
              <div className="createAccountText">Already a member?</div>
              <div className="createAccount" onClick={handleSignIn}>
                SIGN IN
              </div>
            </div>
            <div className="loginFooter"></div>
          </div>
          {showMap && (
            <div className="locationContainer">
              <div className="welcomeHeading">
                <span>LOCATION</span>
              </div>

              {/* <LocatorButton mapObject={mapObject} /> */}
              {/* <CustomMap setMapObject={setMapObject} /> */}
              <CustomMap
                onClose={handleLocationCancel}
                onSave={handleLocationSave}
              />
            </div>
          )}
        </div>
      </main>
    </>
  )
}

const mapStateToProps = (state) => {
  return {}
}

const mapDispatchToProps = (dispatch) => {
  return {
    // testAction: (payload) => dispatch(testAction(payload))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateAccount)
